import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@aihub/core/authorization";

import { MainComponent } from "./main/main.component";

const routes: Routes = [
  { path: "", canActivate: [AuthGuard], component: MainComponent },
  // { path: ':conversation_id', component: ChatThreadComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
